import { Injectable } from '@angular/core';
import { OrderPlacedModalComponent } from '@shared/modals/order-placed-modal/order-placed-modal.component';
import { ModalService } from '@core/services/modal/modal.service';
import { NavigationCancel, NavigationSkipped, Router } from '@angular/router';
import { debounceTime, Subject, switchMap, take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({
	providedIn: 'root',
})
export class PaymentSessionServiceService {
	constructor(
		private modalService: ModalService,
		private router: Router,
	) {
		this.onRedirect();
	}

	private paid = false;
	private redirectToHomePage$ = new Subject<void>();

	markAsPaid(): void {
		this.paid = true;
	}

	markAsUnpaid(): void {
		this.paid = false;
	}

	isPaid(): boolean {
		return this.paid;
	}

	openOrderPaidModal(): void {
		if (!this.isOrderPaidModalOpen()) {
			const orderPaidModal = this.modalService.openResponsiveDialog({
				component: OrderPlacedModalComponent,
				...this.modalService.getConfig(OrderPlacedModalComponent.ID),
			});

			this.setBackRedirectHandler(orderPaidModal);
		}
	}

	setBackRedirectHandler(dialogRef: MatDialogRef<OrderPlacedModalComponent>): void {
		dialogRef
			.afterClosed()
			.pipe(
				switchMap(() => this.router.events),
				filter((event) => event instanceof NavigationSkipped || event instanceof NavigationCancel),
				take(1),
			)
			.subscribe(this.openOrderPaidModal.bind(this));
	}

	redirectToHomePage(): void {
		this.redirectToHomePage$.next();
	}

	onRedirect(): void {
		this.redirectToHomePage$
			.asObservable()
			.pipe(debounceTime(50))
			.subscribe(() => {
				const queryParams = Object.fromEntries(new URLSearchParams(window.location.search));
				void this.router.navigate(['/home'], { replaceUrl: true, queryParams });
			});
	}

	private isOrderPaidModalOpen(): boolean {
		return this.modalService.isModalOpen(OrderPlacedModalComponent);
	}
}
